module.exports = __webpack_public_path__ + "static/media/car-card-inservice.cfc351d4.svg";